import { Script } from "gatsby";
import React from "react";

const GA_IDS = ["G-4ZCKN64G7Q", "G-WBYGP9R7GY"];

export function GoogleAnalytics() {
  if (process.env.NODE_ENV !== "production") {
    return null;
  }

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_IDS[0]}`} strategy="idle" />
      <Script id="gtag-init" strategy="idle">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          ${GA_IDS.map((id) => `gtag('config', '${id}');`).join("\n          ")}
        `}
      </Script>
    </>
  );
}
